import PhoneInput from "react-phone-input-2";
import useTranslator from "../../../hooks/useTranslator";
import { useContext, useEffect, useState } from "react";
import * as Joi from "joi-browser";
import AddSubLLModal from "./AddSubLLModal";
import LandLordContext from "../../../context/landlord/LandLordContext";
import { haveValue } from "../../../helper/common";

const SubLandlord = () => {
  const { _t } = useTranslator();
  const landLordContext = useContext(LandLordContext);
  const { getSubLL } = landLordContext;

  const [showAddSubLL, setShowAddSubLL] = useState(false);
  const [subLandlordList, setSubLandlordList] = useState(null);

  useEffect(() => {
    fetchSubLL();
  }, []);

  const handleShowModal = () => {
    setShowAddSubLL(true);
  };

  const handleCloseModal = () => {
    setShowAddSubLL(false);
    fetchSubLL();
  };

  const fetchSubLL = () => {
    getSubLL()
      .then((res) => {
        const temp_list = res?.data?.landlord_list;
        setSubLandlordList(temp_list);
      })
      .catch((err) => {
        console.log(err, "Error in fetchSubLL");
      });
  };

  return (
    <>
      {showAddSubLL && (
        <AddSubLLModal
          showAddSubLL={showAddSubLL}
          handleCloseModal={handleCloseModal}
        />
      )}
      <button className="btn btngreen" onClick={handleShowModal}>
        {_t("addSubLL")}
      </button>
      <div className="upcoming-box mt-3">
        <h4 className="upcoming-text"> {_t("subLandlordListing")} </h4>
        <table className="upcoming-table landlord-table">
          <thead>
            <tr className="first-row">
              <th> {_t("name")} </th>
              <th> {_t("email")} </th>
              <th> {_t("propertyCount")} </th>
            </tr>
          </thead>

          <tbody>
            {haveValue(subLandlordList)
              ? subLandlordList.map((data) => (
                  <>
                    <tr className="second-row">
                      <td>
                        {data?.fname_companyName || ""} {data?.lname || ""}
                      </td>
                      <td>{data?.email}</td>
                      <td>{data?.properties?.length}</td>
                    </tr>
                  </>
                ))
              : _t("noDetailsFound")}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default SubLandlord;
